import { Copy, ArrowRight, Globe } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { FlowerLogo } from "./FlowerLogo";
import { SERVER_HOST, SERVER_PORT, copyText } from "../lib/api";
import { useI18n } from "../lib/i18n";

export const Hero = ({ status }) => {
  const { t } = useI18n();
  const addr = `${SERVER_HOST}:${SERVER_PORT}`;
  const copy = async () => {
    await copyText(addr);
    toast.success(t("addrCopied"), { description: addr });
  };
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0 grid-bg" />
      <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-[#3FB950]/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-24 lg:pt-28 lg:pb-32 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <span data-testid="hero-badge" className="rise inline-flex items-center gap-2 font-mono text-xs text-[#38BDF8] border border-[#30363D] bg-[#161B22]/80 rounded-full px-3 py-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-[#38BDF8]" /> OSCAR protocol · {addr}
          </span>
          <h1 className="rise mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]" style={{ animationDelay: "80ms" }}>
            {t("heroA")} <br className="hidden sm:block" />
            {t("heroB")} <span className="text-[#3FB950]">{t("heroC")}</span>
          </h1>
          <p data-testid="hero-subtitle" className="rise mt-6 max-w-xl text-base md:text-lg text-[#8B949E] leading-relaxed" style={{ animationDelay: "160ms" }}>
            {t("heroSub")}
          </p>
          <div className="rise mt-10 flex flex-wrap gap-3" style={{ animationDelay: "240ms" }}>
            <Button asChild size="lg" data-testid="hero-register-btn"
              className="rounded-full bg-[#3FB950] text-[#0D1117] hover:bg-[#2EA043] font-semibold px-7 group">
              <a href="#register">{t("heroRegister")} <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" /></a>
            </Button>
            <Button size="lg" variant="outline" onClick={copy} data-testid="hero-copy-address-btn"
              className="rounded-full border-[#30363D] bg-transparent hover:bg-[#21262D] font-mono text-sm">
              <Copy className="mr-2 h-4 w-4" /> {addr}
            </Button>
            <Button asChild size="lg" variant="ghost" data-testid="hero-webclient-btn"
              className="rounded-full text-[#38BDF8] hover:bg-[#21262D] hover:text-[#F0F6FC]">
              <a href="https://kicq.su" target="_blank" rel="noopener noreferrer">
                <Globe className="mr-2 h-4 w-4" /> {t("heroWeb")}
              </a>
            </Button>
          </div>
        </div>
        <div className="lg:col-span-5 flex justify-center lg:justify-end">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-[#3FB950]/20 blur-3xl" />
            <FlowerLogo size={320} online={status?.online !== false} className="relative spin-slow drop-shadow-2xl max-w-[70vw] h-auto" />
          </div>
        </div>
      </div>
    </section>
  );
};
